var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pop-up-events-calendar", style: _vm.style },
    [
      _c("div", { staticClass: "header" }, [
        _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
        _c("i", {
          staticClass: "fa-regular fa-xmark",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "div",
        {
          staticClass: "events-list",
          style: { maxHeight: _vm.style.maxHeight },
        },
        _vm._l(_vm.events, function (event) {
          return _c(
            "div",
            { key: event.id, staticClass: "event-item" },
            [
              _c(
                "Event",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        isPlaceholder: _vm.eventDragged.eventId === event.id,
                        isDraggable: event.editable !== false,
                      },
                    },
                    "Event",
                    event,
                    false
                  ),
                  _vm.$listeners
                )
              ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }